import { render } from "./OrdersIncome.vue?vue&type=template&id=0e055d08"
import script from "./OrdersIncome.vue?vue&type=script&lang=js"
export * from "./OrdersIncome.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__